import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import { routes } from '../../../actions/events';
import store from '../../../store';
import Spinner from '../Spinner';

import './Table.css';
import {
  TableComponent,
  TheadComponent,
  ThComponent,
  TbodyComponent,
  TrComponent,
  TrGroupComponent,
  TdComponent,
} from './TableComponents';

const getTdProps = (state, rowInfo, column) => {
  const tdProps = {
    locationQuery: state.locationQuery,
  };

  if (rowInfo !== undefined) {
    tdProps['data-td-label'] = column.Header;
  }

  return tdProps;
};

const getTrProps = (state, rowInfo, column) => {
  return {
    onClick: () => store.dispatch(routes.routeEventsShow(rowInfo.original.id, state.locationQuery)),
  };
};

class Table extends React.PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
  };

  static defaultProps = {
    data: [],
    isFetching: false,
  };

  render() {
    const {
      data,
      columns,
      isFetching,
      ...rest
    } = this.props;

    return (
      <ReactTable
        resizable={false}
        showPagination={false}
        showPageSizeOptions={false}
        defaultPageSize={data.length}

        TableComponent={TableComponent}
        TheadComponent={TheadComponent}
        ThComponent={ThComponent}
        TbodyComponent={TbodyComponent}
        TrGroupComponent={TrGroupComponent}
        TrComponent={TrComponent}
        TdComponent={TdComponent}

        getTdProps={getTdProps}
        getTrProps={getTrProps}

        data={data}
        columns={columns}
        loading={isFetching}
        loadingText={<Spinner />}
        {...rest}
      />
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/ui/Table/Table.js